const checkAuditChildren = (access) => {
  const auditChildren = [];
  if (access.Audit_Show) {
    auditChildren.push({
      name: "All Audits",
      url: "/audits",
      icon: "icon-grid",
    });
  }
  if (access.Audit_New) {
    auditChildren.push({
      name: "Add New",
      url: "/audits/audit-new",
      icon: "icon-note",
    });
  }
  if (access.AuditCategory_Show) {
    auditChildren.push({
      name: "Categories",
      url: "/audits/categories",
      icon: "icon-layers",
    });
  }
  if (access.Audit_New) {
    auditChildren.push({
      name: "All Coins",
      url: "/coin",
      icon: "icon-note",
    });
  }
  if (access.Audit_New) {
    auditChildren.push({
      name: "Add Coin",
      url: "/coin/coin-new",
      icon: "icon-note",
    });
  }

  return auditChildren;
};

const checkPostChildren = (access) => {
  const postChildren = [];
  if (access.Post_Show) {
    postChildren.push({
      name: "All Posts",
      url: "/posts",
      icon: "icon-grid",
    });
  }
  if (access.Post_New) {
    postChildren.push({
      name: "Add New",
      url: "/posts/post-new",
      icon: "icon-note",
    });
  }
  if (access.PostCategory_Show) {
    postChildren.push({
      name: "Categories",
      url: "/posts/categories",
      icon: "icon-layers",
    });
  }

  return postChildren;
};

const checkUserChildren = (access) => {
  const userChildren = [];
  if (access.Admin_Show) {
    userChildren.push({
      name: "Management",
      url: "/users/management",
      icon: "icon-grid",
    });
  }
  if (access.Role_Show) {
    userChildren.push({
      name: "Roles",
      url: "/users/Roles",
      icon: "icon-note",
    });
  }

  userChildren.push({
    name: "Change Password",
    url: "/users/change-password",
    icon: "icon-note",
  });

  return userChildren;
};

const checkSettingsChildren = (access) => {
  const settingsChildren = [];
  if (access.Setting_Description) {
    settingsChildren.push({
      name: "General",
      url: "/settings/global",
      icon: "icon-grid",
    });
  }
  if (access.Team_Show) {
    settingsChildren.push({
      name: "Team",
      url: "/settings/team",
      icon: "icon-note",
    });
  }
  if (access.FAQ_Show) {
    settingsChildren.push({
      name: "Faqs",
      url: "/settings/faqs",
      icon: "icon-note",
    });
  }
  if (access.Service_Show) {
    settingsChildren.push({
      name: "Services",
      url: "/settings/services",
      icon: "icon-note",
    });
  }
  if (access.Setting_Logs) {
    settingsChildren.push({
      name: "Logs",
      url: "/settings/logs",
      icon: "icon-note",
    });
  }

  return settingsChildren;
};

const checkMenuList = (access) => {
  const menuList = [];
  menuList.push({
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-speedometer",
  });
  if (access.Audit_Show || access.Audit_New || access.AuditCategory_Show) {
    menuList.push({
      name: "Audits",
      icon: "icon-book-open",
      children: checkAuditChildren(access),
    });
  }
  if (access.Post_Show || access.Post_New || access.PostCategory_Show) {
    menuList.push({
      name: "Posts",
      icon: "icon-pencil",
      children: checkPostChildren(access),
    });
  }
  if (access.Contact_Show) {
    menuList.push({
      name: "Contacts",
      url: "/contacts",
      icon: "icon-pencil",
    });
  }
  if (access.Admin_Show || access.Role_Show || true) {
    menuList.push({
      name: "Users",
      icon: "icon-user",
      children: checkUserChildren(access),
    });
  }
  if (
    access.Setting_Description ||
    access.Team_Show ||
    access.FAQ_Show ||
    access.Service_Show ||
    access.Setting_Logs
  ) {
    menuList.push({
      name: "Settings",
      icon: "icon-settings",
      children: checkSettingsChildren(access),
    });
  }
  menuList.push({
    name: "Logout",
    url: "/login",
    icon: "icon-login",
  });

  return menuList;
};

export const accessMenu = (access) => {
  return {
    items: checkMenuList(access),
  };
};



// WEBPACK FOOTER //
// ./src/store/config.js